import { css, jsx } from '@emotion/react';
import { Icon, Link, Typography } from '@zapier/design-system';
import { emitUserInteractionEvent } from '../../../../utils/avroEvents';
const Styles = {
    root: css({
        display: 'flex',
        gap: 30,
    }),
    link: css({
        font: `var(--zds-small-print-2, 500 13px/20px ${Typography.base.fontFamily})`,
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        color: 'var(--zds-gray-warm-10, #201515)',
        '&:hover': {
            color: 'var(--zds-brand-orange, #FF4F00)',
            textDecoration: 'none',
        },
        '&:focus': {
            outline: `1px solid var(--zds-ui-primary-strongest, #503EBD)`,
            outlineOffset: '1px',
            textDecoration: 'none',
        },
    }),
};
export const MegaMenuFooter = (props) => {
    const { links } = props;
    const handleEvent = (text, eventType) => {
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: `MegaNavFooter: ${text}`,
        });
        if (eventType === 'click' && props.onCloseMenu)
            props.onCloseMenu();
    };
    return (jsx("ul", { css: Styles.root, "data-zds": true }, links === null || links === void 0 ? void 0 : links.map((link) => (jsx("li", { key: link.text, "data-zds": true },
        jsx(Link, { color: null, css: Styles.link, href: link.href || undefined, onClick: () => handleEvent(link.text, 'click'), onMouseEnter: () => handleEvent(link.text, 'hover'), target: link.target },
            link.icon && (jsx(Icon, { name: typeof link.icon === 'object' ? link.icon.selected : link.icon, size: 14 })),
            link.text))))));
};
//# sourceMappingURL=MegaMenuFooter.js.map
// @zapier/universal-layout@9.12.4 (a02ac1bd0)
